<div class="border-t border-neutral-600 bg-neutral-800 pb-40 lg:pb-14">
  <div
    class="flex flex-col py-5 text-center text-sm text-white lg:justify-center lg:px-12 lg:text-left"
  >
    <div
      *ngIf="hasLinks()"
      class="flex w-full items-center overflow-x-auto px-5 pr-4 scrollbar-hide"
    >
      <app-block-list
        class="overflow-x-scroll bg-white"
        [blockIdList]="links"
      ></app-block-list>
    </div>
    <div *ngIf="displayPoweredByDood">
      <a
        class="flex w-full items-center justify-center py-3"
        href="https://www.dood.com/corporate/"
        target="_blank"
      >
        <img
          class="h-10"
          [src]="doodLogo"
          [alt]="doodBrand + 'logo'"
        />
      </a>
    </div>
  </div>
</div>
